<template>
  <div class="">
    <div class="detail-wrapper">
      <i class="icon-fanhui iconfont back" @click="returnPage"></i>
      <p class="value p_name">{{data.name}}</p>




      <div class="container" v-if="willShow">
        <p class="value section">{{data.first_party}}</p>
        <p class="section"> <span class="title">启动时间</span> <span class="value">{{data.start_date}}</span></p>
        <p class="section"> <span class="title">结束时间</span> <span class="value">{{data.end_date || '未设置'}}</span></p>
        <p class="section"> <span class="title">负责人</span> <span class="value">{{data.sale}}</span></p>
        <p class="section"> <span class="title">合同</span>  <span class="btn" @click="showContract">查看详情</span></p>
        <p class="section"> <span class="title">项目状态</span>  <span class="btn" @click="fn">查看交付计划</span> <span class="active">{{data.status}}</span></p>
        <div class="row">
          <div class="row-item center has_padding">
            <p class="item-value"> <span class="symbol">¥</span>{{(data.b_money/10000).toFixed(2)}}<span class="unit">(万)</span></p>
            <p class="item-name">已回款金额</p>
          </div>

          <div class="row-item center has_padding">
            <p class="item-value"> <span class="symbol">¥</span>{{(data.p_money/10000).toFixed(2)}}<span class="unit">(万)</span></p>
            <p class="item-name">项目金额</p>
          </div>
        </div>
        <div class="row">
          <div class="row-item center has_padding">
            <p class="item-value"> <span class="symbol">¥</span>{{(data.no_wait_money/10000).toFixed(2)}}<span class="unit">(万)</span></p>
            <p class="item-name">未开发票待回款</p>
          </div>

          <div class="row-item center has_padding">
            <p class="item-value"> <span class="symbol">¥</span>{{(data.y_no_money/10000).toFixed(2)}}<span class="unit">(万)</span></p>
            <p class="item-name">已开发票待回款</p>
          </div>
        </div>

        <!-- 合同详情 -->
        <mt-popup v-model="popupVisible">
          <!-- <img src="" alt="" class="letter" id="letter"> -->
          <div class="contract-wrapper">
            <p style="line-height:6.25rem;text-align:center;font-size:14px;color:#5483D2;" v-if="!contractData.length">暂无合同信息</p>
            <div v-for=" item in contractData">
              <div class="row">
                <div class="row-item center has_padding">
                  <p class="item-value"> {{item.number}}</p>
                  <p class="item-name">合同编号</p>
                </div>

                <div class="row-item center has_padding">
                  <p class="item-value"> {{item.year}}年</p>
                  <p class="item-name">合同年份</p>
                </div>
              </div>

              <img :src="getSrc(item.yun_path)" alt="" class="contract-img">

            </div>
          </div>
        </mt-popup>

      </div>



      <div class="listtxt" v-else>
        <nodata v-if="!deliveryData.length"></nodata>
        <div v-for="item in deliveryData">
          <h2>（交付{{item.period}}稿）</h2>
          <ul>
            <p class="title">计划交付时间</p>
            <li>
              <p>整体交付时间<span>{{item.expect_delivery_time || '暂无'}}</span></p>
            </li>
          </ul>

          <ul>
            <p class="title">实际交付时间</p>
            <li>
              <p>整体交付时间<span>{{item.actual_delivery_time || '暂无'}}</span></p>
            </li>
          </ul>
        </div>
      </div>

    </div>



  </div>
</template>

<script>
import '../assets/css/drillStyle.css'
import nodata from './public/nodata'
import { Popup } from 'mint-ui'
import Vue from 'vue'
Vue.component(Popup.name, Popup)

export default {
  props:[
    'data',
  ],
  components:{
    nodata,
  },
  data () {
    return {
      deliveryData:[], //交付计划数据
      willShow:true,
      popupVisible:false,
      contractData:[], //合同数据
    }
  },
  methods:{
    returnPage () {
      if ( !this.willShow ) {
        this.willShow = true
      } else {
        this.$emit('on-return')
      }
    },

    fn(){ //查看交付计划
      if ( this.willShow ){
        this.willShow = false
        this.$http.getDeliverPlan(this.data.id).then( res => {
          this.deliveryData = res.data
        })
      }else{
        this.willShow = true
      }
    },

    showContract () {
      this.$http.getContract(this.data.id).then( res => {
        this.contractData = res.data
        this.popupVisible = true
      })
    },

    getSrc (path) {
      return `//imservices.b0.upaiyun.com/${path}`
    },

  },
  created () {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detail-wrapper{
  background-color: #fff;
  position: relative;
  width: 9.6875rem;
  margin: 0.1875rem auto;
  padding: 0 0.40625rem;
}
.back{
  position: absolute;
  top: 0.25rem;
  color: #666;
}
.section{
  padding-bottom: 0.1875rem;
}
.section .title {
  color: #999;
  width: 1.5625rem;
  display: inline-block;
}
.detail-wrapper .value {
  color: #666666;
  font-size: 0.40625rem;
}
.detail-wrapper .p_name{
  text-align: center;
  padding: 0.1875rem 0 0.84375rem 0;
}
.section .btn {
  font-size: 0.375rem;
  padding: 0 0.3125rem;
  border-radius: 3.125rem;
  border: 1px solid #5482D2;
  line-height: 1.5;
  color: #5482D2;
  margin: 0.09375rem 0;
  display: inline-block;
}
.section .active{
  font-size: 0.375rem;
  margin-left: 0.1875rem;
}
.has_padding{
  padding-top: 0.59375rem;
}



.listtxt{
  color: #333333;
  width: 100%;
  background: #fff;
  height: 100%;
}
.listtxt h2{
  color: #333333;
  width: 100%;
  text-align: center;
  font-size: 0.4375rem;
  margin-bottom: 1.125rem;
}
.ptxt{
  color: #333333;
  width: 100%;
  text-align: center;
  font-size: 0.4375rem;
  padding-top: 0.4375rem;
}
.listtxt ul{
  width: 100%;
  margin-bottom: 0.46875rem;
}
.listtxt ul li{
  height: 0.9375rem;
  line-height: 0.9375rem;
  border-bottom: 1px solid #ddd;
  position: relative;
}
.listtxt ul li p{
  color: #333333;
  width: 100%;
  text-align: left;
  font-size: 0.4375rem;
  padding-left: 0.8125rem;
}
.listtxt ul li span{
  color: #333333;
  max-width: 50%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  font-size: 0.4375rem;
  position: absolute;
  right: 1.15625rem;
}

.listtxt .look{
  border: 1px solid #5483D2;
  height: 0.625rem;
  line-height: 0.625rem;
  border-radius: 0.125rem;
  font-size: 0.375rem!important;
  margin-top: 2%;
  color: #5483D2!important;
  padding-left: 0.0625rem;
  padding-right: 0.0625rem;
}
.listtxt .title{
  border-left: 0.09375rem solid #5483D2;
  padding-left: 2%;
  margin-left: 0.5rem;
  font-size: 0.4375rem;
  margin-bottom: 0.3125rem;
}
.listtxt .nodata{
  border: 1px solid #ddd;
  color: #ddd!important;
}
.mint-popup{
  width: 80%;
}
.contract-wrapper{
  /*margin: 0.625rem auto;*/
  background-color: #fff;
}
.contract-img{
  width: 90%;
  margin: 10% 5% 20%;
}

</style>



// WEBPACK FOOTER //
// src/components/MyDetail.vue